import { DefaultButton } from "@fluentui/react";
import { useMsal } from "@azure/msal-react";
import { useTranslation } from "react-i18next";

import styles from "./LoginButton.module.css";
import { getRedirectUri, loginRequest, appServicesLogout, getUsername, checkLoggedIn } from "../../authConfig";
import { useState, useEffect, useContext } from "react";
import { LoginContext } from "../../loginContext";

export const LoginButton = ({ compact }: { compact?: boolean } = {}) => {
    const { instance } = useMsal();
    const { loggedIn, setLoggedIn, setUserId } = useContext(LoginContext);
    const activeAccount = instance.getActiveAccount();
    const [username, setUsername] = useState("");
    const { t } = useTranslation();

    useEffect(() => {
        const fetchUsername = async () => {
            setUsername((await getUsername(instance)) ?? "");
        };

        fetchUsername();
    }, []);
    const fetchUserInfo = async (accessToken: string) => {
        const response = await fetch("https://graph.microsoft.com/v1.0/me", {
            headers: { Authorization: `Bearer ${accessToken}` }
        });
        if (response.ok) {
            return await response.json();
        }
        return null;
    };

    const handleLoginPopup = () => {
        instance
            .loginPopup({
                ...loginRequest,
                redirectUri: getRedirectUri()
            })
            .then(async result => {
                // Ensure active account is set after popup login
                if (result?.account) {
                    instance.setActiveAccount(result.account);
                }
                if (result?.accessToken) {
                    const userInfo = await fetchUserInfo(result.accessToken);
                    if (userInfo) {
                        console.log("User:", userInfo.userPrincipalName, userInfo.displayName);
                        setUserId(userInfo.userPrincipalName);
                    }
                }
                setLoggedIn(await checkLoggedIn(instance));
                setUsername((await getUsername(instance)) ?? "");
            })
            .catch(error => console.log(error));
    };

    const handleLogoutPopup = () => {
        if (activeAccount) {
            instance
                .logoutPopup({
                    mainWindowRedirectUri: "/", // redirects the top level app after logout
                    account: instance.getActiveAccount()
                })
                .catch(error => console.log(error))
                .then(async () => {
                    setLoggedIn(await checkLoggedIn(instance));
                    setUsername((await getUsername(instance)) ?? "");
                });
        } else {
            appServicesLogout();
        }
    };
    return (
        <DefaultButton
            text={loggedIn ? (compact ? t("logout") : `${t("logout")}\n${username}`) : t("login")}
            className={styles.loginButton}
            onClick={loggedIn ? handleLogoutPopup : handleLoginPopup}
        ></DefaultButton>
    );
};
